
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');


window.toastr.options = {
    'closeButton': false,
    'debug': false,
    'newestOnTop': false,
    'progressBar': true,
    'positionClass': 'toast-top-center',
    'preventDuplicates': false,
    'showDuration': 200,
    'hideDuration': 200,
    'timeOut': 4000,
    'extendedTimeOut': 2000,
    'showEasing': 'linear',
    'hideEasing': 'linear',
    'showMethod': 'fadeIn',
    'hideMethod': 'fadeOut'
};

console.info('%c Programista: Mateusz Łoś ✉️ mateusz@3w-projekt.pl', 'width: 100%;background: #000; color: #fff; font-size: 26px; padding: 20px 60px;');
console.info('%c Dla: Inovatica  ↗️ https://inovatica.com | Zamawiający: Komtur Polska ↗️ https://www.komtur.com ', 'background: #000; color: #fff; font-size: 20px; padding: 16px 26px;');


$(function () {
    $('input').iCheck({
        checkboxClass: 'icheckbox_square-blue',
        radioClass: 'iradio_square-blue',
        increaseArea: '20%' // optional
    });

    $('[data-toggle="popover"]').popover();
    $('[data-toggle="tooltip"]').tooltip();

    $('.datepicker').datepicker({
        format: 'yyyy-mm-dd',
        language: 'pl',
        autoclose: true,
        orientation: 'bottom',
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js